/**
 * Unique internal key for the aggregated "Others" category in Creative Share chart.
 * Must match AGGREGATED_OTHERS_KEY in @/lib/chartUtils so the aggregated bar gets the "others" color.
 */
export const AGGREGATED_OTHERS_KEY = "__CREATIVE_SHARE_AGGREGATED_OTHERS__";

/** Display label shown to users for the aggregated Others category */
export const AGGREGATED_OTHERS_DISPLAY_NAME = "Others";
